import React from 'react';
import PropTypes from 'prop-types';

const PlainTextEmailDisplay = ({ textContent }) => {
    if (!textContent) {
        return (
            <div style={{
                padding: '40px',
                textAlign: 'center',
                color: '#94a3b8'
            }}>
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>📄</div>
                <div style={{ fontSize: '14px', fontWeight: '500' }}>No plain text content available</div>
            </div>
        );
    }

    // Convert URLs to clickable links
    const linkifyText = (text) => {
        const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (urlRegex.test(part)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: '#3b82f6',
                            textDecoration: 'none',
                            borderBottom: '1px solid #93c5fd',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.color = '#1d4ed8';
                            e.target.style.borderBottomColor = '#3b82f6';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.color = '#3b82f6';
                            e.target.style.borderBottomColor = '#93c5fd';
                        }}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    // Convert email addresses to mailto links
    const processEmailAddresses = (content) => {
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

        if (typeof content === 'string') {
            const parts = content.split(emailRegex);
            return parts.map((part, index) => {
                if (emailRegex.test(part)) {
                    return (
                        <a
                            key={`email-${index}`}
                            href={`mailto:${part}`}
                            style={{
                                color: '#8b5cf6',
                                textDecoration: 'none',
                                borderBottom: '1px solid #c4b5fd'
                            }}
                        >
                            {part}
                        </a>
                    );
                }
                return linkifyText(part);
            });
        }

        return content;
    };

    return (
        <div style={{
            padding: '24px',
            background: '#f8fafc',
            minHeight: '200px',
            maxHeight: '600px',
            overflow: 'auto'
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
            }}>
                {/* Line numbers and content */}
                <pre style={{
                    margin: 0,
                    fontFamily: "'SF Mono', 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', monospace",
                    fontSize: '13px',
                    lineHeight: '1.7',
                    color: '#374151',
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word'
                }}>
                    {processEmailAddresses(textContent)}
                </pre>
            </div>

            {/* Character count */}
            <div style={{
                marginTop: '12px',
                fontSize: '12px',
                color: '#9ca3af',
                textAlign: 'right'
            }}>
                {textContent.length.toLocaleString()} characters
            </div>
        </div>
    );
};

PlainTextEmailDisplay.propTypes = {
    textContent: PropTypes.string
};

export default PlainTextEmailDisplay;
